import { SalesFunnelsPageHeader } from '@pages/SalesFunnels/SalesFunnelsRegistry/components/SalesFunnelsPageHeader';

import { SalesFunnels } from '@pages/SalesFunnels/SalesFunnelsRegistry/SalesFunnels.main';

export { SalesFunnels, SalesFunnelsPageHeader };
